import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import TitleBar from '../../Layout/titleBar'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField';
import Turnos from './turnos'
const styles = theme => ({
  root: {
    flexGrow: 1,
    maxWidth: '20%',
    backgroundColor: 'transparent',
  },
  tabsRoot: {
    borderBottom: '1px solid #e8e8e8',
  },
  tabsIndicator: {
    backgroundColor: '#46C082',
  },
  tabRoot: {
    textTransform: 'initial',
    minWidth: 72,
    fontWeight: theme.typography.fontWeightRegular,
    '&:hover': {
      color: '#46C082',
      opacity: 1,
    },
    '&$tabSelected': {
      fontWeight: theme.typography.fontWeightMedium,
    },
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
});

function TabContainer(props) {
    return (
      <Typography component="div">
        {props.children}
      </Typography>
    );
  }

const Calendario = ({ classes, fecha, setFecha, value, setValue, calendarioPedidos, refresh, setRefresh, setOpened, opened}) => {

  const calcularConfirmados = () => {    
    //const { calendarios } = calendarioPedidos;
    if(calendarioPedidos === undefined)
      return 0;
    var calendarios = calendarioPedidos.calendarios;
    var cont = 0;
    if(calendarios.length !== 0) {
      for(var calendario of calendarios) {
        for(var pedido of calendario.pedidos) {
          if(pedido.descripcion === 'Confirmado') {
            cont = cont + 1;
          }
        }
      }
    }
    return cont;
  }

  const calcularPreparados = () => {    
    //const { calendarios } = calendarioPedidos;
    if(calendarioPedidos === undefined)
      return 0;
    var calendarios = calendarioPedidos.calendarios;
    var cont = 0;
    if(calendarios.length !== 0) {
      for(var calendario of calendarios) {
        for(var pedido of calendario.pedidos) {
          if(pedido.descripcion === 'Preparado') {
            cont = cont + 1;
          }
        }
      }
    }
    return cont;
  }

  const calcularEntregados = () => {    
    //const { calendarios } = calendarioPedidos;
    if(calendarioPedidos === undefined)
      return 0;
    var calendarios = calendarioPedidos.calendarios;
    var cont = 0;
    if(calendarios.length !== 0) {
      for(var calendario of calendarios) {
        for(var pedido of calendario.pedidos) {
          if(pedido.descripcion === 'Entregado') {
            cont = cont + 1;
          }
        }
      }
    }
    return cont;
  }

    const handleChange = (value) => {
        setValue(value);
    };

    return (
        <>
            <div>
                <TitleBar 
                    title={'Calendario de pedidos'} 
                    buttons={
                    <div>  
                        <TextField
                            id="date"
                            label="Fecha"
                            type="date"
                            value={fecha}
                            onChange={(e) => setFecha(e.target.value)}
                            className={classes.textField}
                            InputLabelProps={{
                            shrink: true,
                            }}
                        />                             
                        <Button variant="contained" className="btnPrincipal" onClick={() => {setRefresh(!refresh)}}>ACTUALIZAR</Button>     
                    </div>
                    }
                />
            </div>
            <div className={classes.root}>
                <Tabs
                value={value}
                onChange={(e, v) => handleChange(v)}
                classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
                >
                <Tab
                    disableRipple
                    classes={{ root: classes.tabRoot }}
                    label="PICK UP"
                />
                <Tab
                    disableRipple
                    classes={{ root: classes.tabRoot }}
                    label="DELIVERY"
                />
                </Tabs>
            </div>

            <div className='totalizadorContainer' style={{background: '#E8C615'}}>
              <div className='totalizadorTitle' style={{color: '#E5DFA3'}}>
                Confirmados
              </div>
              <div className='totalizadorQty'>
                {(calcularConfirmados())?calcularConfirmados():0}
              </div>
            </div>
            <div className='totalizadorContainer' style={{background: '#159CE8'}}>
              <div className='totalizadorTitle' style={{color: '#A3D1E5'}}>
                Preparados
              </div>
              <div className='totalizadorQty'>
                {(calcularPreparados())?calcularPreparados():0}
              </div>
            </div>
            <div className='totalizadorContainer' style={{background: '#15E850'}}>
              <div className='totalizadorTitle' style={{color: '#C0E5A3'}}>
                Entregados
              </div>
              <div className='totalizadorQty'>
                {(calcularEntregados())?calcularEntregados():0}
              </div>
            </div>
            <div className='totalizadorContainer' style={{background: '#A415E8'}}>
              <div className='totalizadorTitle' style={{color: '#C4A3E5'}}>
                Total
              </div>
              <div className='totalizadorQty'>
                {(calcularConfirmados() + calcularPreparados() + calcularEntregados())?(calcularConfirmados() + calcularPreparados() + calcularEntregados()):0}
              </div>
            </div>
            
            {value === 0 && <TabContainer><Turnos {...{calendarioPedidos, value, fecha, setOpened, opened}} /></TabContainer>}
            {value === 1 && <TabContainer><Turnos {...{calendarioPedidos, value, fecha, setOpened, opened}} /></TabContainer>}
        </>
    );
  }

Calendario.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Calendario);